export const setClock = (value) => ({ type: 'SET_CLOCK', value });
export const showClock = (value, position) => ({
	type: 'SHOW_CLOCK',
	value,
	position,
});
